<nz-modal [(nzVisible)]="visible" [nzWidth]="900" [nzFooter]="null" (nzOnCancel)="closeModal()">
  <ng-container *nzModalContent>
    <h3 nz-typography>View Datasets</h3>
    <div class="view-dataset-modal">
      <div nz-row [nzGutter]="24" class="dataset-wrapper">
        <div nz-col [nzSpan]="canViewSponsorData ? 12 : 24" class="mb1">
          <div class="table-container">
            <h4 nz-typography class="nfl-form-label">{{ collaboration?.orgType | uppercase }}</h4>
            <nz-table
              #ownerDatasetsTable
              [nzData]="collaboration?.ownerDatasets || []"
              [nzShowPagination]="false"
              [nzSize]="'small'"
              [nzVirtualItemSize]="10"
              [nzScroll]="{ y: '200px' }"
              [nzBordered]="true"
              [nzOuterBordered]="true"
              [nzNoResult]="noDataTemplate"
            >
              <thead>
                <tr>
                  <th nzWidth="50%">Schema</th>
                  <th nzWidth="50%">Table</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dataset of collaboration?.ownerDatasets">
                  <td>{{ dataset.schemaName }}</td>
                  <td>{{ dataset.tableName }}</td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
        <div nz-col [nzSpan]="12" *ngIf="canViewSponsorData" class="mb1">
          <div class="table-container">
            <h4 nz-typography class="nfl-form-label">{{ collaboration?.partnerOrgType | uppercase }}</h4>
            <nz-table
              #partnerDatasetsTable
              [nzData]="collaboration?.partnerDatasets || []"
              [nzShowPagination]="false"
              [nzSize]="'small'"
              [nzVirtualItemSize]="10"
              [nzScroll]="{ y: '200px' }"
              [nzNoResult]="noDataTemplate"
              [nzOuterBordered]="true"
              [nzBordered]="true"
            >
              <thead>
                <tr>
                  <th nzWidth="50%">Schema</th>
                  <th nzWidth="50%">Table</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dataset of collaboration?.partnerDatasets">
                  <td>{{ dataset.schemaName }}</td>
                  <td>{{ dataset.tableName }}</td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </div>
    </div>
    <!-- Button wrapper -->
    <div nz-row>
      <div class="w100 button-row">
        <button nz-button nzType="primary" (click)="closeModal()">Close</button>
      </div>
    </div>
  </ng-container>
  <ng-template #noDataTemplate>
    <div class="no-data-container">
      <nz-empty nzNotFoundImage="simple" nzNotFoundContent="No data available"></nz-empty>
    </div>
  </ng-template>
</nz-modal>
